import apiClient from './client';
import type { LoginResponse } from '../types/user';
import { decodeUser } from '../utils/decodeApiStrings';

function decodeLoginResponse(data: LoginResponse): LoginResponse {
  return { ...data, user: decodeUser(data.user) };
}

export async function login(email: string, password: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', { email, password });
  return decodeLoginResponse(data);
}

export async function loginWithMicrosoft(idToken: string): Promise<LoginResponse> {
  const { data } = await apiClient.post<LoginResponse>('/auth/microsoft', { id_token: idToken });
  return decodeLoginResponse(data);
}

export async function refreshToken(token: string): Promise<{ access_token: string; expires_in: number }> {
  const { data } = await apiClient.post('/auth/refresh', null, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return data;
}

export async function logout(): Promise<void> {
  await apiClient.post('/auth/logout');
}

export async function getPermissions(): Promise<{
  user_id: number;
  is_admin: boolean;
  role_keys: string[];
  has_bridge_access: boolean;
}> {
  const { data } = await apiClient.get('/auth/permissions');
  return data;
}

export async function getVersion(): Promise<{ version: string; git: { display: string } }> {
  const { data } = await apiClient.get('/version');
  return data;
}
